import React, { useEffect, useRef, useState } from "react"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import { ICalendar } from "components/ProjectSpecificComponents/Stores/PTKMStore/ptkmStore"
import { observer } from "mobx-react"
import { useTranslation } from "react-i18next"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import InputMask from "react-input-mask"
import Input from "components/ProjectNonSpecificComponents/Elements/Input"
import moment from "moment"

type DateInput = {
	label: string
	section: keyof ICalendar
	withTime?: boolean
}

const DateInput = observer(({ label, section, withTime = false }: DateInput) => {
	const { t } = useTranslation()
	const ptkmStore = usePTKMStore()

	const [date, setDate] = useState<string | undefined>()
	const [dateList, setDateList] = useState<string[]>([])

	useEffect(() => {
		parseDateStringToArr()
	}, [ptkmStore.calendar[section]])

	const parseDateStringToArr = () => {
		if (section !== "week" && ptkmStore.calendar[section]) {
			var _dateList: string = ptkmStore.calendar[section]
			if (_dateList.includes(",")) {
				setDateList(_dateList.split(","))
			} else {
				setDateList([_dateList])
			}
		} else {
			setDateList([])
		}
	}

	const rmDate = (rmDate: string) => {
		const newDateArr: string[] = dateList.filter((_date) => rmDate != _date)
		const newDateString: string = newDateArr.toString()

		ptkmStore.editCalendar({
			...ptkmStore.calendar,
			[section]: newDateString,
		})

		if (!newDateString) parseDateStringToArr()
	}

	var inputRef: any = useRef()

	const addDate = () => {
		const isDateValid = !moment(date, "DD/MM/YYYY", true).isValid()

		if (
			isDateValid ||
			section === "week" ||
			!date ||
			date.includes("_") ||
			dateList.includes(date)
		) {
			try {
				return inputRef.current.focus()
			} catch (err) {}
			return
		}

		setDateList((pS) => {
			const newList = [...pS, date]
			ptkmStore.editCalendar({
				...ptkmStore.calendar,
				[section]: newList.toString(),
			})
			return newList
		})

		setDate("")
	}

	return (
		<>
			<div className="flex flex-row content-between w-full pt-4">
				<label className="w-1/3 pt-4">{label}:</label>
				<div className="flex flex-col w-2/3">
					<div
						className="w-full border-gray border-solid border rounded-lg flex flex-row flex-wrap"
						style={{ minHeight: 50, maxHeight: 150, overflow: "hidden auto" }}
					>
						{dateList?.map((date, i) => (
							<div
								key={date}
								className="rounded pl-1 flex flex-row bg-gray-100  justify-between m-1"
								style={{ width: withTime ? "200px" : "130px", height: "min-content" }}
							>
								{date}
								<div
									className="bg-gray-200 rounded pl-1 pr-1 cursor-pointer"
									style={{ marginLeft: "1ch" }}
									onClick={() => rmDate(date)}
								>
									{"x"}
								</div>
							</div>
						))}
					</div>
					<Whitespace x=".5" />
					<div className="flex flex-row">
						<InputMask
							mask={withTime ? "99/99/9999 99:99" : "99/99/9999"}
							placeholder={withTime ? "dd/MM/yyyy hh:mm" : "dd/MM/yyyy"}
							id="exception-input"
							value={date}
							onChange={(e) => setDate(e.target.value)}
						>
							{(inputProps: any) => (
								<Input
									ref={inputRef}
									{...inputProps}
									style={{ maxWidth: 200, textAlign: "center" }}
								/>
							)}
						</InputMask>
						<div
							className=" bg-gray-200 rounded ml-2 cursor-pointer"
							style={{ padding: "6px 8px" }}
							onClick={addDate}
						>
							+
						</div>
					</div>
				</div>
			</div>
		</>
	)
})

export default DateInput
